var map = {
	"./banjo/1.mp4": 3898,
	"./banjo/2.mp4": 6509,
	"./banjo/3.mp4": 1304,
	"./banjo/4.mp4": 569,
	"./banjo/5.mp4": 8475,
	"./banjo/6.mp4": 9875,
	"./banjo/7.mp4": 3972,
	"./cafler/1.mp4": 1999,
	"./cafler/2.mp4": 4323,
	"./cafler/3.mp4": 9145,
	"./cafler/4.mp4": 6618,
	"./cafler/5.mp4": 7310,
	"./cafler/6.mp4": 255,
	"./dev/1.mp4": 1035,
	"./dev/2.mp4": 4356,
	"./dev/3.mp4": 7659,
	"./dev/4.mp4": 2605,
	"./dev/5.mp4": 8589,
	"./dibi/1.mp4": 9819,
	"./dibi/2.mp4": 1038,
	"./dibi/3.mp4": 9297,
	"./dibi/4.mp4": 6709,
	"./dibi/5.mp4": 2271,
	"./lapele/1.mp4": 5442,
	"./lapele/2.mp4": 3927,
	"./lapele/3.mp4": 2058,
	"./lapele/4.mp4": 2464,
	"./lapele/5.mp4": 4531,
	"./lapele/6.mp4": 436,
	"./naggura/1.mp4": 784,
	"./naggura/2.mp4": 5681,
	"./naggura/3.mp4": 6551,
	"./naggura/4.mp4": 995,
	"./naggura/5.mp4": 8651,
	"./naggura/6.mp4": 4969,
	"./pronatal/1.mp4": 6477,
	"./pronatal/2.mp4": 6182,
	"./pronatal/3.mp4": 6188,
	"./pronatal/4.mp4": 8675,
	"./pronatal/5.mp4": 5254,
	"./soultek/1.mp4": 2596,
	"./soultek/2.mp4": 7427,
	"./soultek/3.mp4": 8255,
	"./soultek/4.mp4": 5799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3292;